import { For, Show } from "solid-js";
import { decrireProbleme, ErreurDonnees } from "../donnees/erreurs";

export function EtatChargement() {
  return (
    <section class="etat" role="status" aria-live="polite" aria-busy="true">
      <span class="etat__indicateur" aria-hidden="true" />
      <p>Chargement du portefeuille…</p>
    </section>
  );
}

const PROBLEMES_AFFICHES = 10;

export function EtatErreur(props: { erreur: unknown; onReessayer: () => void }) {
  const erreurDonnees = () => (props.erreur instanceof ErreurDonnees ? props.erreur : null);
  const titre = () =>
    erreurDonnees()?.nature === "validation"
      ? "Les données reçues ne sont pas valides"
      : "Les données n'ont pas pu être chargées";
  const message = () =>
    props.erreur instanceof Error ? props.erreur.message : "Erreur inattendue.";
  const problemes = () => erreurDonnees()?.problemes ?? [];

  return (
    <section class="etat etat--erreur" role="alert">
      <h2>{titre()}</h2>
      <p>{message()}</p>
      <Show when={problemes().length > 0}>
        <ul class="etat__problemes">
          <For each={problemes().slice(0, PROBLEMES_AFFICHES)}>
            {(p) => <li>{decrireProbleme(p)}</li>}
          </For>
        </ul>
        <Show when={problemes().length > PROBLEMES_AFFICHES}>
          <p class="discret">… et {problemes().length - PROBLEMES_AFFICHES} autre(s).</p>
        </Show>
      </Show>
      <button type="button" class="bouton" onClick={() => props.onReessayer()}>
        Réessayer
      </button>
    </section>
  );
}

export function EtatVide() {
  return (
    <section class="etat" role="status">
      <h2>Aucun projet à afficher</h2>
      <p>
        La source de données est accessible mais ne contient aucun projet. Vérifier le contenu de{" "}
        <code>poc/data/projets.csv</code> puis relancer l'import des données.
      </p>
    </section>
  );
}
